import { IChemicalPhraseFill } from 'models/product';
import { getPhraseSpec } from 'components/product/ProductUpdateForm/fields/hazard-placeholders';
import { PHRASE_FILL_CODE_FIELDS } from 'constants/bulk-import';

import { IImportColumn, IProductExcel } from '../types';
import { getEnumValue } from './excel/cell';

export type TPhraseFillField = keyof typeof PHRASE_FILL_CODE_FIELDS;

// The row holds codes as an array (AI, saved product) or as text (Excel); resolve both to codes.
export const getRowPhraseCodes = (data: IProductExcel, fillsField: TPhraseFillField): string[] => {
  const column: IImportColumn = {
    _id: '',
    isMandatory: false,
    title: '',
    field: PHRASE_FILL_CODE_FIELDS[fillsField],
    dataType: 'string',
    isEnumType: true,
  };
  const codes = getEnumValue(column, data);
  return Array.isArray(codes) ? codes : [];
};

// Keeps one non-blank fill per {code, slotIndex}, for codes the product has and slots the code defines.
// Values are not trimmed: a leading space is the separator before the fill (see resolvePhrase).
export const sanitizePhraseFills = (fills: unknown, codes: string[]): IChemicalPhraseFill[] | undefined => {
  if (!Array.isArray(fills)) return undefined;

  const activeCodes = new Set(codes);
  const usedSlots = new Set<string>();

  return fills.flatMap(item => {
    if (!item || typeof item !== 'object') return [];
    const { code, slotIndex, value } = item as Partial<IChemicalPhraseFill>;
    if (typeof code !== 'string' || !activeCodes.has(code)) return [];

    const spec = getPhraseSpec(code);
    if (!spec || !Number.isInteger(slotIndex) || slotIndex! < 0 || slotIndex! >= spec.slots.length) return [];
    if (typeof value !== 'string' || !value.trim()) return [];

    const slotKey = `${code}:${slotIndex}`;
    if (usedSlots.has(slotKey)) return [];
    usedSlots.add(slotKey);

    return [{ code, slotIndex: slotIndex!, value }];
  });
};
